export default function Surveys() {
  window.location = '/home'
  return null
}
